import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useNotificationStore = defineStore('notification', () => {
  const notifications = ref([])
  
  // States for confirmation dialog
  const confirmState = ref({
    isOpen: false,
    title: '',
    message: '',
    confirmLabel: 'Confirmar',
    cancelLabel: 'Cancelar',
    type: 'default', // default, destructive
    resolve: null
  })

  let nextId = 1

  const notify = (notification) => {
    const id = nextId++
    const duration = notification.duration || 5000
    
    notifications.value.push({
      id,
      title: notification.title || '',
      message: notification.message,
      type: notification.type || 'info',
      duration
    })

    if (duration > 0) {
      setTimeout(() => {
        remove(id)
      }, duration)
    }

    return id
  }

  const remove = (id) => {
    const index = notifications.value.findIndex(n => n.id === id)
    if (index > -1) {
      notifications.value.splice(index, 1)
    }
  }

  const success = (message, title = '') => notify({ message, title, type: 'success' })
  const error = (message, title = '') => notify({ message, title, type: 'error', duration: 8000 })
  const warning = (message, title = '') => notify({ message, title, type: 'warning', duration: 6000 })
  const info = (message, title = '') => notify({ message, title, type: 'info' })

  const ask = (options) => {
    confirmState.value = {
      isOpen: true,
      title: options.title || '¿Estás seguro?',
      message: options.message || '',
      confirmLabel: options.confirmLabel || 'Confirmar',
      cancelLabel: options.cancelLabel || 'Cancelar',
      type: options.type || 'default',
      resolve: null
    }

    return new Promise((resolve) => {
      confirmState.value.resolve = resolve
    })
  }

  const confirmAction = () => {
    if (confirmState.value.resolve) {
      confirmState.value.resolve(true)
    }
    confirmState.value.isOpen = false
  }

  const cancelAction = () => {
    if (confirmState.value.resolve) {
      confirmState.value.resolve(false)
    }
    confirmState.value.isOpen = false
  }

  return {
    notifications,
    confirmState,
    success,
    error,
    warning,
    info,
    showSuccess: success,
    showError: error,
    showWarning: warning,
    showInfo: info,
    remove,
    ask,
    confirmAction,
    cancelAction
  }
})
